import { forwardRef } from 'react';
import { Button } from '../../button/index.js';
import { jsx } from 'react/jsx-runtime';

const SelectAction = /*#__PURE__*/forwardRef((props, ref) => {
  // @ts-ignore to get rid of ref typing error
  return /*#__PURE__*/jsx(Button, {
    ref: ref,
    ...props
  });
});

export { SelectAction };
//# sourceMappingURL=component.js.map
